import './short-events.sass'
import 'rc-collapse/assets/index.css';

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';

import Title from 'components/track-events/title/Title';
import Accordion from 'components/track-events/accordion/Accordion';
import ContentLoader from 'controls/content-loader/ContentLoader';

import request from 'actions/request';

const TOP_CONTROLS_HEIGHT = 105;

class ShortEvents extends React.Component {
  componentDidMount() {
    this.checkTrackEvents();
  }

  componentDidUpdate() {
    this.checkTrackEvents();
  }

  checkTrackEvents() {
    if (this.props.tracks.chosenItems.length !== 1) {
      return;
    }

    let chosenTrack = this.props.tracks.chosenItems[0];
    if ((this.props.trackEventsPending === null)
      || ((this.props.trackEventsPending === false)
        && (this.props.trackEvents.trackId !== chosenTrack.id)
      )
    ) {
      this.props.request(
        ['trackEvents', 'get'],
        'get',
        'TRACK_EVENTS',
        { trackId: chosenTrack.id }
      );
    }

    this.resize();
  }

  resize(event) {
    this.container.style.height = window.innerHeight - TOP_CONTROLS_HEIGHT + 'px';
  }

  eventsAvaliable() {
    if (this.props.trackEvents.items
      && (Object.keys(this.props.trackEvents.items).length > 0)
      && (this.props.tracks.chosenItems.length === 1)
      && (this.props.tracks.chosenItems[0].id === this.props.trackEvents.trackId)
    ) {
      return true;
    }

    return false;
  }

  buildBody() {
    if (!this.eventsAvaliable()) {
      return '';
    }

    let chosenTrack = this.props.tracks.chosenItems[0];
    return <Accordion
      items={ this.props.trackEvents.items }
      trackId={ chosenTrack.id }
      isShort={ true }
    />;
  }

  render() {
    return (
      <div className={ 'tracks-tree-short-events ' + (this.eventsAvaliable() ? 'is-shown' : '') }
        ref={(container) => { this.container = container; }}
      >
        { this.buildBody() }
      </div>
    );
  }
}

ShortEvents.propTypes = {
  tracks: PropTypes.shape({
    chosenItems: PropTypes.array
  }).isRequired,
  trackEvents: PropTypes.shape({
    items: PropTypes.object
  }).isRequired,
  trackEventsPending: PropTypes.oneOf([true, false, null])
};

function mapStateToProps(state) {
  return {
    tracks: state.tracks,
    trackEventsPending: state.trackEvents.pending,
    trackEvents: state.trackEvents
  };
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShortEvents);
